import { createElement, useRef, useEffect } from "react";
import type { ComponentType } from "react";
import styles from "./SettingsNavigation.module.scss";
import BellIcon from "@/components/SVGComponents/BellIcon";
import CardIcon from "@/pages/Dashboard/components/icons/CardIcon";
import { combineClasses } from "@/lib/utils";

export interface SettingsNavItem {
  id: string;
  label: string;
  icon: ComponentType<any>;
  iconProps?: Record<string, any>;
  isDanger?: boolean;
  isOutlined?: boolean;
  desktopHidden?: boolean;
}

const NAV_ITEMS: SettingsNavItem[] = [
  // {
  //   id: "general",
  //   label: "General",
  //   icon: SettingsIcon,
  //   isOutlined: true,
  // },
  // {
  //   id: "app_experience",
  //   label: "App experience",
  //   icon: UsersIcon,
  // },
  {
    id: "notifications",
    label: "Notifications",
    icon: BellIcon,
  },
  {
    id: "payments_tax",
    label: "Payments & tax",
    icon: CardIcon,
  },
  // {
  //   id: "data_privacy",
  //   label: "Data & privacy",
  //   icon: PastEventIcon,
  //   iconProps: { width: 18, height: 18 },
  // },
  // {
  //   id: "danger_zone",
  //   label: "Danger zone",
  //   icon: CrossIcon,
  //   iconProps: { withBg: false, stroke: "currentColor", strokeWidth: 2 },
  //   isDanger: true,
  // },
];

interface SettingsNavigationProps {
  activeId?: string;
  onSelect?: (id: string) => void;
}

const SettingsNavigation = ({
  activeId = "notifications",
  onSelect,
}: SettingsNavigationProps) => {
  const itemRefs = useRef<Record<string, HTMLButtonElement | null>>({});

  useEffect(() => {
    if (typeof window !== "undefined" && window.innerWidth <= 768) {
      const el = itemRefs.current[activeId];
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "nearest",
        });
      }
    }
  }, [activeId]);

  return (
    <nav className={styles.navigationCard} aria-label="Settings navigation">
      <span className={styles.sectionLabel}>SETTINGS</span>
      <ul className={styles.navList}>
        {NAV_ITEMS.map((item) => {
          const isActive = item.id === activeId;
          const isOutlined = item.isOutlined && !isActive;

          return (
            <li
              key={item.id}
              className={combineClasses(
                styles.navListItem,
                item.desktopHidden && styles.desktopHidden,
              )}
            >
              <button
                ref={(el) => {
                  itemRefs.current[item.id] = el;
                }}
                type="button"
                className={combineClasses(
                  styles.navItem,
                  isActive && styles.active,
                  isOutlined && styles.outlined,
                  item.isDanger && styles.danger,
                )}
                onClick={() => onSelect?.(item.id)}
                aria-current={isActive ? "page" : undefined}
              >
                <span className={styles.navIconWrapper}>
                  {createElement(item.icon, {
                    className: styles.navIcon,
                    ...(item.iconProps || {}),
                  })}
                </span>
                <span className={styles.navLabel}>{item.label}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default SettingsNavigation;
